import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { BrandIconNowDelivery } from '@redteclab/brand-icons'
import { IconArrowRight } from '@redteclab/icons'

import { Link } from 'base-ui'

import { useNowGeneralContext } from '../../../../now'

export const ProductNowDeliveryBox: FC = () => {
  const { productPageNowDialogControls } = useNowGeneralContext()

  return (
    <div className="mb-3 w-full rounded-3xl bg-light-primary-low p-4">
      <div className="flex">
        <div>
          <div className="mr-2.5 flex size-12 items-center justify-center rounded-full bg-light-primary-low">
            <BrandIconNowDelivery className="size-12 fill-dark-brand" />
          </div>
        </div>
        <div className="flex flex-col">
          <span className="text-s font-medium text-dark-primary-max">
            <FormattedMessage id="now.prompt.headline.deliverytimeAndAvailability" />
          </span>
          <span className="mt-1 text-xs text-dark-primary-strong">
            <FormattedMessage id="now.prompt.body.enterZipForAccurateDeliveryEstimations" />
          </span>
          <Link
            className="mt-2 inline-flex cursor-pointer items-center gap-1 text-s font-medium text-dark-primary-max no-underline"
            data-qa-id="buybox-check-now"
            onClick={productPageNowDialogControls.handleOpen}
            slots={{
              root: 'button',
            }}
            type="button"
          >
            <FormattedMessage id="now.prompt.link.checkAvailabilityNow" />
            <IconArrowRight className="size-6 text-dark-brand" />
          </Link>
        </div>
      </div>
    </div>
  )
}
